import PropTypes from 'prop-types';
// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import {
    Checkbox,
    FormGroup,
    FormControlLabel,
    FormHelperText,
    FormControl,
} from '@mui/material';

// ----------------------------------------------------------------------

RHFCheckbox.propTypes = {
    name: PropTypes.string,
    label: PropTypes.node,
};

export function RHFCheckbox({ name, label, ...other }) {
    const {
        control,
        formState: { errors },
    } = useFormContext();

    const fieldError = errors[name]?.message;

    return (
        <FormControl error={!!fieldError} component="fieldset">
            <Controller
                name={name}
                control={control}
                render={({ field }) => (
                    <FormControlLabel
                        control={<Checkbox {...field} checked={field.value} />}
                        label={label}
                        {...other}
                    />
                )}
            />
            {!!fieldError && (
                <FormHelperText>{fieldError}</FormHelperText>
            )}
        </FormControl>
    );
}
